import { getSelectedTableView } from 'owa-mail-list-store';
export default function isGroupSelected() {
    var selectedTable = getSelectedTableView();
    return selectedTable && selectedTable.tableQuery.type == 2 /* Group */;
}
//# sourceMappingURL=isGroupSelected.js.map